import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { getContactInquiry } from '../api/CRUD/getContactInquiry';
import { getCorporateInquiry } from '../api/CRUD/getCorporateInquiry';
import { getCustomInquiry } from '../api/CRUD/getCustomInquiry';
import { getDonationInquiry } from '../api/CRUD/getDonationInquiry';
import ViewInquiry from '../components/view';
import { HeadCells, dataFields } from '../constant';
import { Inquiry } from '../type';
import { useNotificationStore } from '@/stores/notifications';
import { useDisclosure } from '@/hooks/useDisclosure';
import { ContentLayout } from '@/components/Layout';
import CustomTable from '@/components/Elements/Table/CustomTable';
import { Confirm } from '@/components/Elements/Dialog/Confirm';
import { Dialog, Spinner } from '@/components/Elements';
//import { HeadCells } from '@/features/users/constant';

import { axios } from '@/lib/axios';
import '../styles/styles.css';

export const Inquiries = () => {
    const { close, open, isOpen } = useDisclosure();
    const { addNotification } = useNotificationStore();

    const [searchVal, setSearchVal] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    // const [inquiry, setInquiry] = useState<Inquiry[]>([]);
    const [liveinquiry, setLiveInquiry] = useState<Inquiry[]>([]);
    const [contactinquiry, setContactInquiry] = useState<Inquiry[]>([]);
    const [corporateinquiry, setCorporateInquiry] = useState<Inquiry[]>([]);
    const [custominquiry, setCustomInquiry] = useState<Inquiry[]>([]);
    const [donationinquiry, setDonationInquiry] = useState<Inquiry[]>([]);
    const [checkboxinquiry, setCheckboxInquiry] = useState<string>('All');
    const [viewInquiry, setviewInquiry] = useState<Inquiry | null>(null);
    // const [locationFilter, setLocationFilter] = useState();
    const [confirmMsg, setConfirmMsg] = useState<User | null>(null);
    const [value, setValue] = useState(0);

    const handleChange = (newValue: any) => {
        const a = parseInt(newValue.target.id);
        setValue(a);
    };

    const handleSearch = (e: any) => {
        setSearchVal(e.target.value);
    };

    async function getInquiry() {
        setIsLoading(true);
        let resContactMod = [];
        let resCorporateMod = [];
        let resCustomMod = [];
        let resDonationMod = [];
        const resContactNew = await getContactInquiry();
        const resContact = resContactNew.reverse();
        resContactMod = resContact.map((item) => {
            const inquiry: any = {};
            inquiry.id = item.id;
            inquiry.contact_full_name = item.contact_full_name;
            inquiry.req_type = 'Contact Inquiries';
            inquiry.customer = item.contact_full_name;
            inquiry.contact_phone = item.contact_phone;
            inquiry.contact_email = item.contact_email;
            inquiry.contact_comment = item.contact_comment;
            inquiry.inquiry_read = item.inquiry_read;
            inquiry.inquiry_active = item.inquiry_active;
            inquiry.created_at = item.created_at;
            inquiry.updated_at = item.updated_at;

            return inquiry;
        });
        const resCorporateNew = await getCorporateInquiry();
        const resCorporate = resCorporateNew.reverse();
        resCorporateMod = resCorporate.map((item) => {
            const inquiry: any = {};
            inquiry.id = item.id;
            inquiry.corporate_request_user_id = item.corporate_request_user_id;
            inquiry.req_type = 'Corporate Account Request';
            inquiry.customer = item.corporate_request_corporate_name;
            inquiry.corporate_request_user_position = item.corporate_request_user_position;
            inquiry.corporate_request_corporate_name = item.corporate_request_corporate_name;
            inquiry.corporate_request_phone = item.corporate_request_phone;
            inquiry.corporate_request_email = item.corporate_request_email;
            inquiry.corporate_request_site = item.corporate_request_site;
            inquiry.corporate_request_address_1 = item.corporate_request_address_1;
            inquiry.corporate_request_address2 = item.corporate_request_address2;
            inquiry.corporate_request_city = item.corporate_request_city;
            inquiry.corporate_request_state = item.corporate_request_state;
            inquiry.corporate_request_zip = item.corporate_request_zip;
            inquiry.inquiry_read = item.inquiry_read;
            inquiry.inquiry_status = item.inquiry_status;
            inquiry.created_at = item.created_at;
            inquiry.update_at = item.update_at;

            return inquiry;
        });
        const resCustomNew = await getCustomInquiry();
        const resCustom = resCustomNew.reverse();
        resCustomMod = resCustom.map((item) => {
            const inquiry: any = {};
            inquiry.id = item.id;
            inquiry.custom_first_name = item.custom_first_name;
            inquiry.req_type = 'Custom Order Request';
            inquiry.customer = item.custom_first_name + ' ' + item.custom_last_name;
            inquiry.custom_last_name = item.custom_last_name;
            inquiry.custom_company = item.custom_company;
            inquiry.custom_phone = item.custom_phone;
            inquiry.custom_email = item.custom_email;
            inquiry.custom_request_type = item.custom_request_type;
            inquiry.custom_order_type = item.custom_order_type;
            inquiry.custom_cookie_quantity = item.custom_cookie_quantity;
            inquiry.custom_special_instructions = item.custom_special_instructions;
            inquiry.inquiry_read = item.inquiry_read;
            inquiry.inquiry_active = item.inquiry_active;
            inquiry.created_at = item.created_at;
            inquiry.update_at = item.update_at;

            return inquiry;
        });
        const resDonationNew = await getDonationInquiry();
        const resDonation = resDonationNew.reverse();
        resDonationMod = resDonation.map((item) => {
            const inquiry: any = {};
            inquiry.id = item.id;
            inquiry.donation_first_name = item.donation_first_name;
            inquiry.req_type = 'Donation Request';
            inquiry.customer = item.donation_first_name + ' ' + item.donation_last_name;
            inquiry.donation_last_name = item.donation_last_name;
            inquiry.donation_phone = item.donation_phone;
            inquiry.donation_email = item.donation_email;
            inquiry.donation_company = item.donation_company;
            inquiry.donation_company_site = item.donation_company_site;
            inquiry.donation_city = item.donation_city;
            inquiry.donation_is_nonprofit = item.donation_is_nonprofit;
            inquiry.donation_event_name = item.donation_event_name;
            inquiry.donation_event_site = item.donation_event_site;
            inquiry.donation_event_description = item.donation_event_description;
            inquiry.donation_event_datetime = item.donation_event_datetime;
            inquiry.donation_event_location_name = item.donation_event_location_name;
            inquiry.donation_event_attendance = item.donation_event_attendance;
            inquiry.donation_event_location_address = item.donation_event_location_address;
            inquiry.donation_is_previous_done = item.donation_is_previous_done;
            inquiry.donation_is_hbexclusivedessert = item.donation_is_hbexclusivedessert;
            inquiry.donation_is_hbexclusivecookie = item.donation_is_hbexclusivecookie;
            inquiry.donation_desired = item.donation_desired;
            inquiry.donation_comments = item.donation_comments;
            inquiry.inquiry_read = item.inquiry_read;
            inquiry.inquiry_active = item.inquiry_active;
            inquiry.created_at = item.created_at;
            inquiry.updated_at = item.updated_at;

            return inquiry;
        });
        setContactInquiry(resContactMod);
        setCorporateInquiry(resCorporateMod);
        setCustomInquiry(resCustomMod);
        setDonationInquiry(resDonationMod);
        setIsLoading(false);
    }
    useEffect(() => {
        getInquiry();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [close]);

    if (isLoading) {
        return (
            <div className="w-full h-48 flex justify-center items-center">
                <Spinner size="lg" />
            </div>
        );
    }
    const filteredCustomInquiry = custominquiry
        ?.filter((inquiry: Inquiry) => {
            // if (searchVal) {
            if (searchVal) {
                return (
                    inquiry?.customer?.toLowerCase()?.includes(searchVal.toLowerCase()) ||
                    inquiry?.req_type?.toLowerCase()?.includes(searchVal.toLowerCase())
                );
            } else return inquiry;
            // }
            // else {
            //     if (checkboxinquiry == 'New') {
            //         return inquiry.filter((data) => {
            //             return data.inquiry_read == 0 && data.inquiry_active == 1;
            //         });
            //     } else if (checkboxinquiry == 'Viewed') {
            //         inquiry.filter((data) => {
            //             return data.inquiry_read == 1 && data.inquiry_active == 1;
            //         });
            //     } else if (checkboxinquiry == 'All') {
            //         return inquiry;
            //     }
            // }
        })
        .filter((el: any) => {
            if (checkboxinquiry == 'New') {
                // return el.filter((data: any) => {
                return el.inquiry_read == 0 && el.inquiry_active == 1;
                // });
            } else if (checkboxinquiry == 'Viewed') {
                // el.filter((el: any) => {
                return el.inquiry_read == 1 && el.inquiry_active == 1;
                // });
            } else if (checkboxinquiry == 'Deleted') {
                // el.filter((el: any) => {
                return el.inquiry_active == 0;
                // });
            } else {
                return el;
            }
        });

    const filteredCorporateInquiry = corporateinquiry
        ?.filter((liveinquiry: Inquiry) => {
            // if (searchVal) {
            if (searchVal) {
                return (
                    liveinquiry?.customer?.toLowerCase()?.includes(searchVal.toLowerCase()) ||
                    liveinquiry?.req_type?.toLowerCase()?.includes(searchVal.toLowerCase())
                );
            } else return liveinquiry;
        })
        .filter((el: any) => {
            if (checkboxinquiry == 'New') {
                // return el.filter((data: any) => {
                return el.inquiry_read == 0 && el.inquiry_status == 'new';
                // });
            } else if (checkboxinquiry == 'Viewed') {
                // el.filter((el: any) => {
                return el.inquiry_read == 1 && el.inquiry_status == 'approved';
                // });
            } else if (checkboxinquiry == 'Deleted') {
                // el.filter((el: any) => {
                return el.inquiry_active == 0;
                // });
            } else {
                return el;
            }
        });

    const filteredDonationInquiry = donationinquiry
        ?.filter((liveinquiry: Inquiry) => {
            if (searchVal) {
                if (searchVal) {
                    return (
                        liveinquiry?.customer?.toLowerCase()?.includes(searchVal.toLowerCase()) ||
                        liveinquiry?.req_type?.toLowerCase()?.includes(searchVal.toLowerCase())
                    );
                }
            } else {
                return liveinquiry;
            }
        })
        .filter((el: any) => {
            if (checkboxinquiry == 'New') {
                // return el.filter((data: any) => {
                return el.inquiry_read == 0 && el.inquiry_active == 1;
                // });
            } else if (checkboxinquiry == 'Viewed') {
                // el.filter((el: any) => {
                return el.inquiry_read == 1 && el.inquiry_active == 1;
                // });
            } else if (checkboxinquiry == 'Deleted') {
                // el.filter((el: any) => {
                return el.inquiry_active == 0;
                // });
            } else {
                return el;
            }
        });

    const filteredContactInquiry = contactinquiry
        ?.filter((liveinquiry: Inquiry) => {
            if (searchVal) {
                if (searchVal) {
                    return (
                        liveinquiry?.customer?.toLowerCase()?.includes(searchVal.toLowerCase()) ||
                        liveinquiry?.req_type?.toLowerCase()?.includes(searchVal.toLowerCase())
                    );
                }
            } else {
                return liveinquiry;
            }
        })
        .filter((el: any) => {
            if (checkboxinquiry == 'New') {
                // return el.filter((data: any) => {
                return el.inquiry_read == 0 && el.inquiry_active == 1;
                // });
            } else if (checkboxinquiry == 'Viewed') {
                // el.filter((el: any) => {
                return el.inquiry_read == 1 && el.inquiry_active == 1;
                // });
            } else if (checkboxinquiry == 'Deleted') {
                // el.filter((el: any) => {
                return el.inquiry_active == 0;
                // });
            } else {
                return el;
            }
        });

    const updateCustomInquiry = async (id, flag) => {
        await axios.post('v1/update-custom-orders-inquiries', {
            id: id,
            inquiry_read: flag == 1 ? true : false,
        });
    };
    const updateCorporateInquiry = async (id, flag) => {
        await axios.post('v1/update-corporate-request-inquiries', {
            id: id,
            inquiry_read: flag == 1 ? true : false,
        });
    };
    const updateDonationInquiry = async (id, flag) => {
        await axios.post('v1/update-donation-inquiries', {
            id: id,
            inquiry_read: flag == 1 ? true : false,
        });
    };

    const updateContactInquiry = async (id, flag) => {
        await axios.post('v1/update-contact-inquiries', {
            id: id,
            inquiry_read: flag == 1 ? true : false,
        });
    };

    const deleteCustomInquiry = async (id) => {
        await axios.post('v1/update-custom-orders-inquiries', {
            id: id,
            inquiry_active: false,
        });
    };
    const deleteCorporateInquiry = async (id) => {
        await axios.post('v1/update-corporate-request-inquiries', {
            id: id,
            inquiry_active: false,
        });
    };
    const deleteDonationInquiry = async (id) => {
        await axios.post('v1/update-donation-inquiries', {
            id: id,
            inquiry_active: false,
        });
    };
    const deleteContactInquiry = async (id) => {
        await axios.post('v1/update-contact-inquiries', {
            id: id,
            inquiry_active: false,
        });
    };

    const handleDelete = async (inquiryData: Inquiry) => {
        if (inquiryData.req_type == 'Custom Order Request') {
            await deleteCustomInquiry(inquiryData.id).then(() => {
                addNotification({
                    type: 'success',
                    title: 'Inquiry Deleted',
                });
            });
            getInquiry();
            setConfirmMsg(null);
            closeDialog();
        } else if (inquiryData.req_type == 'Corporate Account Request') {
            await deleteCorporateInquiry(inquiryData.id).then(() => {
                addNotification({
                    type: 'success',
                    title: 'Inquiry Deleted',
                });
            });
            getInquiry();
            setConfirmMsg(null);
            closeDialog();
        } else if (inquiryData.req_type == 'Donation Request') {
            await deleteDonationInquiry(inquiryData.id).then(() => {
                addNotification({
                    type: 'success',
                    title: 'Inquiry Deleted',
                });
            });
            getInquiry();
            setConfirmMsg(null);
            closeDialog();
        } else if (inquiryData.req_type == 'Contact Inquiries') {
            await deleteContactInquiry(inquiryData.id).then(() => {
                addNotification({
                    type: 'success',
                    title: 'Inquiry Deleted',
                });
            });
            getInquiry();
            setConfirmMsg(null);
            closeDialog();
        }
    };

    const selectedUserAction = ({ action, data }: any) => {
        switch (action) {
            case 'view':
                setviewInquiry(data);
                open();
                value == 0
                    ? updateCustomInquiry(data.id, data.inquiry_active == 0 ? 1 : 1)
                    : value == 1
                    ? updateCorporateInquiry(data.id, data.inquiry_active == 0 ? 1 : 1)
                    : value == 2
                    ? updateDonationInquiry(data.id, data.inquiry_active == 0 ? 1 : 1)
                    : updateContactInquiry(data.id, data.inquiry_active == 0 ? 1 : 1);

                break;
            case 'delete':
                value == 0
                    ? deleteCustomInquiry(data.id)
                    : value == 1
                    ? deleteCorporateInquiry(data.id)
                    : value == 2
                    ? deleteDonationInquiry(data.id)
                    : deleteContactInquiry(data.id);
                setConfirmMsg(data);
                break;
            default:
                return null;
        }
    };

    const closeDialog = () => {
        setviewInquiry(null);
        getInquiry();
        close();
    };

    const LocationOptions = new Set(liveinquiry?.map((item) => item.location_name));

    function TabPanel(props: any) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 0 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    function a11yProps(index: any) {
        return {
            id: index,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return (
        <ContentLayout
            title=""
            topNavBarData={{
                num:
                    value == 0
                        ? custominquiry.length
                        : value == 1
                        ? corporateinquiry.length
                        : value == 2
                        ? donationinquiry.length
                        : contactinquiry.length,
                title: 'Inquiries',
            }}
        >
            {confirmMsg ? (
                <Confirm
                    btnTitle={'Delete'}
                    onClose={() => setConfirmMsg(null)}
                    onSuccess={() => handleDelete(confirmMsg)}
                />
            ) : null}
            <div className="table-header">
                <form>
                    <div className="row">
                        <div className="col-12 col-md-9">
                            <div className="flex">
                                <div className="input-group search">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                        value={searchVal}
                                        onChange={(e) => handleSearch(e)}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">
                                            <i className="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className="checkboxes flex items-center justify-center ml-4 gap-4 pt-2">
                                    <div className="all-bx">
                                        <label className="checkbox">
                                            <input
                                                type="checkbox"
                                                id="all"
                                                name="all"
                                                value={checkboxinquiry}
                                                checked={checkboxinquiry == 'All' ? true : false}
                                                onChange={() => {
                                                    setCheckboxInquiry('All');
                                                }}
                                            />
                                            <span>All</span>
                                        </label>
                                    </div>
                                    <div className="all-bx">
                                        <label className="checkbox">
                                            <input
                                                type="checkbox"
                                                id="new"
                                                name="new"
                                                value={checkboxinquiry}
                                                checked={checkboxinquiry == 'New' ? true : false}
                                                onChange={() => {
                                                    setCheckboxInquiry('New');
                                                }}
                                            />
                                            <span>New</span>
                                        </label>
                                    </div>
                                    <div className="all-bx">
                                        <label className="checkbox">
                                            <input
                                                type="checkbox"
                                                id="Viewed"
                                                name="Viewed"
                                                value={checkboxinquiry}
                                                checked={checkboxinquiry == 'Viewed' ? true : false}
                                                onChange={() => {
                                                    setCheckboxInquiry('Viewed');
                                                }}
                                            />
                                            <span>Viewed</span>
                                        </label>
                                    </div>
                                    {/* <div className="all-bx">
                                        <label className="checkbox">
                                            <input
                                                type="checkbox"
                                                id="Answered"
                                                name="Answered"
                                                value={checkboxinquiry}
                                                checked={
                                                    checkboxinquiry == 'Answered' ? true : false
                                                }
                                                onChange={() => {
                                                    setCheckboxInquiry('Answered');
                                                }}
                                            />
                                            <span>Answered</span>
                                        </label>
                                    </div> */}
                                    <div className="all-bx">
                                        <label className="checkbox">
                                            <input
                                                type="checkbox"
                                                id="Deleted"
                                                name="Deleted"
                                                value={checkboxinquiry}
                                                checked={
                                                    checkboxinquiry == 'Deleted' ? true : false
                                                }
                                                onChange={() => {
                                                    setCheckboxInquiry('Deleted');
                                                }}
                                            />
                                            <span>Deleted</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 0 }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        className="prTabs inquiry-dash-tabs"
                        style={{ paddingTop: '10px' }}
                    >
                        <Tab
                            label="Custom Order Request"
                            className="left-inquiry"
                            value={0}
                            {...a11yProps(0)}
                            style={{
                                border: '1px solid  #c8d4df',
                                borderRadius: '6px 0px 0 0',
                                width: '25%',
                                maxWidth: '25%',
                            }}
                        />
                        <Tab
                            label="Corporate Account Request"
                            className="right-inquiry"
                            value={1}
                            {...a11yProps(1)}
                            style={{
                                border: '1px solid  #c8d4df',
                                borderRadius: '0px 6px 0 0',
                                width: '25%',
                                maxWidth: '25%',
                            }}
                        />
                        <Tab
                            label="Donation Request"
                            className="right-inquiry"
                            value={2}
                            {...a11yProps(2)}
                            style={{
                                border: '1px solid  #c8d4df',
                                borderRadius: '0px 6px 0 0',
                                width: '25%',
                                maxWidth: '25%',
                            }}
                        />
                        <Tab
                            label="General Inquiries"
                            className="right-inquiry"
                            value={3}
                            {...a11yProps(3)}
                            style={{
                                border: '1px solid  #c8d4df',
                                borderRadius: '0px 6px 0 0',
                                width: '25%',
                                maxWidth: '25%',
                            }}
                        />
                    </Tabs>
                </Box>

                <TabPanel className="inquiry-tab-panel" value={value} index={0}>
                    <CustomTable
                        tableData={filteredCustomInquiry}
                        headCells={HeadCells}
                        dataFields={dataFields}
                        selectedUserAction={selectedUserAction}
                        // rowOptions={true}
                        // optionMenu={['delete']}
                    />
                </TabPanel>
                <TabPanel className="inquiry-tab-panel" value={value} index={1}>
                    <CustomTable
                        tableData={filteredCorporateInquiry}
                        headCells={HeadCells}
                        dataFields={dataFields}
                        selectedUserAction={selectedUserAction}
                        // rowOptions={true}
                        // optionMenu={['delete']}
                    />
                </TabPanel>
                <TabPanel className="inquiry-tab-panel" value={value} index={2}>
                    <CustomTable
                        tableData={filteredDonationInquiry}
                        headCells={HeadCells}
                        dataFields={dataFields}
                        selectedUserAction={selectedUserAction}
                        // rowOptions={true}
                        // optionMenu={['delete']}
                    />
                </TabPanel>
                <TabPanel className="inquiry-tab-panel" value={value} index={3}>
                    <CustomTable
                        tableData={filteredContactInquiry}
                        headCells={HeadCells}
                        dataFields={dataFields}
                        selectedUserAction={selectedUserAction}
                        // rowOptions={true}
                        // optionMenu={['delete']}
                    />
                </TabPanel>
            </Box>

            <Dialog isOpen={isOpen} onClose={closeDialog} paperWidth={'55%'}>
                <div className="modals-contents">
                    {viewInquiry && (
                        <ViewInquiry
                            inquiryData={viewInquiry}
                            closeDialog={closeDialog}
                            selectedUserAction={selectedUserAction}
                        />
                    )}
                </div>
            </Dialog>
        </ContentLayout>
    );
};
